import moment from 'moment';

/**
 * Compute BMI
 * @param weight 
 * @param height 
 */
export function computeBmi(weight: number, height: number): number {
  const bmi = (weight / (height * height)) * 10000;
  return Math.round(bmi * 100) / 100;
}


export function computeEDCUsingUS(aog: number, usDate: Date, format: string = "MM/DD/YY"): string {
  let days = 280 - aog;
  return moment(usDate).add(days, 'days').format(format)
}

export function computeEDCUsingLMP(date: Date, format: string = "MM/DD/YY"): string {
  return moment(date).add(9, 'months').add(7, 'days').format(format)
}

export function computeAOGUsingLMP(date: Date): string {
  let item = moment(new Date()).diff(moment(date))
  let newItem = moment.duration(item);

  let week = Math.floor(newItem.asDays() / 7);
  let days = Math.floor(newItem.asDays() - (week * 7));

  if (week == 0 && days == 0) {
      return "---"
  }

  if (week == 0) {
      let desc = days == 1 ? 'day' : 'days';
      return days + " " + desc;
  }

  if (week != 0 && days == 0) {
      let desc = week == 1 ? 'week' : 'weeks';
      return week + " " + desc;
  }

  return week + " w / " + days + " d"
}
